import { Component } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTab3Directive,
	PageTabsLayout,
	PageTabsWidget,
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget } from '../../../ui/widget';
import { DevoCommitmentsPageService } from './devo-commitments.page.service';
import { DevoCommitmentsTab1Part } from './tabs/tab-1/devo-commitments-tab-1.part';
import { DevoCommitmentsTab2Part } from './tabs/tab-2/devo-commitments-tab-2.part';
import { DevoCommitmentsViewsPart } from './views/devo-commitments-views.part';


@Component({
	selector: 'devo-commitments-page',
	standalone: true,
	imports: [
		DevoCommitmentsTab1Part,
		DevoCommitmentsTab2Part,
		DevoCommitmentsViewsPart,
		PageTab1Directive,
		PageTab2Directive,
		PageTab3Directive,
		PageTabsWidget,
		DroplistWidget,
		ToolbarWidget],
	templateUrl: './devo-commitments.page.html',
})
export class DevoCommitmentsPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	constructor(public pageService: DevoCommitmentsPageService) { }

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}